"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeSegments = function (value) { return (value.toLowerCase().split(" ").filter(Boolean)); };
var fuzzyFilter = function (options, matchable, allMatch) {
    if (allMatch === void 0) { allMatch = false; }
    if (!matchable) {
        return options;
    }
    var terms = makeSegments(matchable);
    return options.filter(function (_a) {
        var label = _a.label;
        if (allMatch) {
            return terms.every(function (term) { return (label.toLowerCase().includes(term)); });
        }
        return makeSegments(label).some(function (segment) { return (terms.some(function (term) { return segment.startsWith(term) || segment.startsWith("#" + term); })); });
    });
};
exports.default = fuzzyFilter;
